import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const createMedicineSlice = createAsyncThunk(
  "medicineMaster/createMedicine",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/medicineMaster/createMedicine",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data?.token,
          },
        }
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getMedicineSlice = createAsyncThunk(
  "medicineMaster/getAllMedicines",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/medicineMaster/getAllMedicines",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data?.token,
          },
        }
      ); 
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getMedicineByIdSlice = createAsyncThunk(
  "medicineMaster/getMedicineById",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/medicineMaster/getMedicineById",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data?.token,
          },
        }
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const updateMedicineSlice = createAsyncThunk(
  "medicineMaster/updateMedicine",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/medicineMaster/updateMedicine", data, {
        headers: {
          "Content-Type": "application/json",
          token: data?.token,
        },
      });
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deleteMedicineSlice = createAsyncThunk(
  "medicineMaster/deleteMedicine",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/medicineMaster/deleteMedicine", data, {
        headers: {
          "Content-Type": "application/json",
          token: data?.token,
        },
      });
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const initialState = {
  loading: false,
  medicine: [],
  medicineInfo: [],
  createMedicineSuccessMessage: null,
  createMedicineErrorMessage: null,
  updateMedicineSuccessMessage: null,
  updateMedicineErrorMessage: null,
  deleteMedicineSuccessMessage: null,
  deleteMedicineErrorMessage: null,
  searchMedicineErrorMessage: null,
};

const medicineMasterSlice = createSlice({
  name: "medicineMaster",
  initialState,
  reducers: {
    resetCreateMedicineMessage: (state) => {
      state.createMedicineSuccessMessage = null;
      state.createMedicineErrorMessage = null;
    },
    resetUpdateMedicineMessage: (state) => {
      state.updateMedicineSuccessMessage = null;
      state.updateMedicineErrorMessage = null;
    },
    resetDeleteMedicineMessage: (state) => {
      state.deleteMedicineSuccessMessage = null;
      state.deleteMedicineErrorMessage = null;
    },
    resetSearchMedicineMessage: (state) => {
      state.searchMedicineErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createMedicineSlice.pending, (state) => {
        state.loading = true;
        state.createMedicineSuccessMessage = null;
        state.createMedicineErrorMessage = null;
      })
      .addCase(createMedicineSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.createMedicineErrorMessage = action?.payload?.result?.message;
        } else {
          state.createMedicineSuccessMessage = action?.payload?.result?.message;
        }
      })
      .addCase(createMedicineSlice.rejected, (state, action) => {
        state.loading = false;
        state.createMedicineErrorMessage = action?.payload?.result?.message;
      })
      .addCase(getMedicineSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMedicineSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.searchMedicineErrorMessage = action?.payload?.result?.message;
        }
        state.medicine = action?.payload?.result?.list;
      })
      .addCase(getMedicineSlice.rejected, (state, action) => {
        state.loading = false;
        state.searchMedicineErrorMessage = action?.payload?.result?.message;
      })
      .addCase(getMedicineByIdSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMedicineByIdSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.medicineInfo = action?.payload?.result?.list;
      })
      .addCase(getMedicineByIdSlice.rejected, (state, action) => {
        state.loading = false;
        state.searchMedicineErrorMessage = action?.payload?.result?.message;
      })
      .addCase(updateMedicineSlice.pending, (state) => {
        state.loading = true;
        state.updateMedicineSuccessMessage = null;
        state.updateMedicineErrorMessage = null;
      })
      .addCase(updateMedicineSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.updateMedicineErrorMessage = action?.payload?.result?.message;
        } else {
          state.updateMedicineSuccessMessage = action?.payload?.result?.message;
        }
      })
      .addCase(updateMedicineSlice.rejected, (state, action) => {
        state.loading = false;
        state.updateMedicineErrorMessage = action?.payload?.result?.message;
      })
      .addCase(deleteMedicineSlice.pending, (state) => {
        state.loading = true;
        state.deleteMedicineSuccessMessage = null;
        state.deleteMedicineErrorMessage = null;
      })
      .addCase(deleteMedicineSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.deleteMedicineErrorMessage = action?.payload?.result?.message;
        } else {
          state.deleteMedicineSuccessMessage = action?.payload?.result?.message;
        }
      })
      .addCase(deleteMedicineSlice.rejected, (state, action) => {
        state.loading = false;
        state.deleteMedicineErrorMessage = action?.payload?.result?.message;
      });
  },
});

export const {
  resetCreateMedicineMessage,
  resetUpdateMedicineMessage,
  resetDeleteMedicineMessage,
  resetSearchMedicineMessage,
} = medicineMasterSlice.actions;

export default medicineMasterSlice.reducer;
